import { useSelector } from "react-redux";
import { EXTERNAL_LOGIN_URL } from "../../../../../consts";
import { RootState } from "../../../../../store/reducer/_store";
import { getIsIpDomain } from "../../../../../utils";
import { PDLButton } from "../../../../components/dna";

const isIpDomain = getIsIpDomain();

const BackToLoginButton = () => {
  const token = useSelector((state: RootState) => state.sessionContext.token);

  const handleBackToLogin = () => {
    if (token) {
      return window.location.replace("/home");
    }

    if (isIpDomain) {
      return window.location.replace("/login?manual=true");
    }

    window.location.replace(EXTERNAL_LOGIN_URL);
  };

  return (
    <PDLButton onClick={handleBackToLogin}>
      {token ? "Voltar para tela incial" : "Voltar para o login"}
    </PDLButton>
  );
};

export default BackToLoginButton;
